import { render } from "./Bar.vue?vue&type=template&id=8b26d560&ts=true"
import script from "./Bar.vue?vue&type=script&lang=ts"
export * from "./Bar.vue?vue&type=script&lang=ts"

import "./Bar.vue?vue&type=style&index=0&id=8b26d560&lang=css"

import exportComponent from "/var/lib/jenkins/jobs/api2-production/workspace/api2/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__